module.exports = __webpack_public_path__ + "fonts/texgyrepagella-bold.61d9fbdc.otf";